export default __webpack_public_path__ + "static/wrv2-1000-f1bfc051c2c3f66db25c9484285f4392.jpg";